<app-formulario #ctrl URL="sucursal-configuracion" titulo="Configuración / Sucursal" [dato]="dato"></app-formulario>
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">
      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar();  ctrl.cambiar_sucursal();">
        <section class="hero is-primary">
          <div class="hero-body">
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="padding: 2rem 2rem !important; overflow:auto; height: 86vh;"
          formGroupName='configuracion'>

          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="catalogos" (click)="ctrl.cargarCatalogo('tipos_medios', 'tipo-medio'); ctrl.cargarCatalogo('tipos_redes_sociales', 'tipo-red-social');
                     ctrl.cargarCatalogo('tipos_monedas', CFDI_PATH+'/api/v1/catalogo-moneda');
                     ctrl.cargarCatalogo('catalogos_impuestos', CFDI_PATH+'/api/v1/catalogo-impuesto');
                     ctrl.cargarCatalogo('catalogos_factores', CFDI_PATH+'/api/v1/catalogo-factor'); ctrl.subir['logo'] = false; ctrl.subir['fondo'] = false;">

          </a>
          <a id="regimen" (click)="ctrl.cargarCatalogo('catalogos_regimenes_fiscales', CFDI_PATH+'/api/v1/catalogo-regimen-fiscal?persona='+ctrl.dato.controls.configuracion.controls.facturacion.controls.persona.value);"></a>


          <div class="tabs is-boxed">
            <ul>
              <li [ngClass]="{ 'is-active' : tab == 1}">
                <a (click)="tab=1">
                  <span class="icon ">
                    <i class="fa fa-home"></i>
                  </span>
                  <span>General</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 2}">
                <a (click)="tab=2">
                  <span class="icon ">
                    <i class="fa fa-building"></i>
                  </span>
                  <span>Sucursal</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 3}">
                <a (click)="tab=3">
                  <span class="icon ">
                    <i class="icon-id-card2"></i>
                  </span>
                  <span>Contacto</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 4}">
                <a (click)="tab=4">
                  <span class="icon ">
                    <i class="fa fa-cog"></i>
                  </span>
                  <span>Configuración y ajustes</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 5}">
                <a (click)="tab=5">
                  <span class="icon ">
                    <i class="icon-file"></i>
                  </span>
                  <span>Facturación</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- general -->
          <div [ngClass]="{ 'is-hidden': tab != 1}">
            <div class="columns">
              <div class="column is-6">
                <div class="field">
                  <label class="label">Nombre:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="nombre" formControlName="nombre">
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="field">
                  <label class="label">Clave de trabajo:</label>

                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('configuracion').get('clave').hasError('required')}"
                      placeholder="Centro de trabajo" formControlName="clave">
                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('configuracion').get('clave').hasError('required')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="help is-danger" *ngIf="ctrl.dato.get('configuracion').get('clave').hasError('required')">Este campo es
                      requerido.</span>
                  </p>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Sitio:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="sitio" formControlName="sitio">
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label">Correo:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="correo" formControlName="correo">
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label">Telefono:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="telefono" formControlName="telefono">
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-12">
                <div class="field">
                  <label class="label">Dirección:</label>
                  <div class="control has-icons-left has-icons-right">
                    <textarea class="textarea" rows="3" placeholder="Dirección" formControlName="direccion"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6">

                <div class="box">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img *ngIf="ctrl.subir['logo']" [src]="'data:image/jpeg;base64,'+ctrl.dato.get('configuracion').value.logo">
                        <img *ngIf="!ctrl.subir['logo']" [src]="ctrl.dato.get('configuracion').value.logo != '' ? ctrl.API_PATH + '/adjunto/configuracion/' + ctrl.dato.controls.configuracion.controls.logo.value  : './assets/128x128.png'">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="field">
                        <label class="label">Logo:</label>
                        <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('configuracion').value.logo == ''">

                          <div class="file has-name">
                            <label class="file-label">
                              <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.configuracion.controls.logo, false, 'logo')"
                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label">
                                  Seleccionar archivo
                                </span>
                              </span>

                            </label>
                          </div>
                        </div>
                        <input foto type="hidden" formControlName="logo">
                        <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.configuracion.controls.logo, 'configuracion')"
                          *ngIf="ctrl.dato.get('configuracion').value.logo != ''">
                          <span class="icon">
                            <i class="fa fa-trash"></i>
                          </span>
                          &nbsp; Eliminar logo.
                        </button>
                      </div>
                    </div>
                  </article>
                </div>
              </div>

              <div class="column is-6">
                <div class="box">
                  <article class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img *ngIf="ctrl.subir['fondo']" [src]="'data:image/jpeg;base64,'+ctrl.dato.get('configuracion').value.fondo">
                        <img *ngIf="!ctrl.subir['fondo']" [src]="ctrl.dato.get('configuracion').value.fondo != '' ? ctrl.API_PATH + '/adjunto/configuracion/' + ctrl.dato.controls.configuracion.controls.fondo.value  : './assets/128x128.png'">
                      </figure>
                    </div>
                    <div class="media-content">
                      <div class="field">
                        <label class="label">Fondo:</label>
                        <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.get('configuracion').value.fondo == ''">

                          <div class="file has-name">
                            <label class="file-label">
                              <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.configuracion.controls.fondo, false, 'fondo')"
                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                              <span class="file-cta">
                                <span class="file-icon">
                                  <i class="fa fa-upload"></i>
                                </span>
                                <span class="file-label">
                                  Seleccionar archivo
                                </span>
                              </span>

                            </label>
                          </div>
                        </div>
                        <input foto type="hidden" formControlName="fondo">
                        <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.configuracion.controls.fondo, 'configuracion')"
                          *ngIf="ctrl.dato.get('configuracion').value.fondo != ''">
                          <span class="icon">
                            <i class="fa fa-trash"></i>
                          </span>
                          &nbsp; Eliminar fondo.
                        </button>
                      </div>
                    </div>
                  </article>
                </div>
              </div>

            </div>
            <div class="field">
              <label class="label">Reintegro:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Escriba un texto para las politicas de reintegro, que aparece en los tickets"
                  formControlName="reintegro">
                                                                  </textarea>
              </div>
            </div>

            <div class="field">
              <label class="label">Mensaje:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Escriba un texto para impresion extra en el ticket"
                  formControlName="mensaje">
                                                                  </textarea>
              </div>
            </div>

          </div>

          <!-- empresa -->
          <div [ngClass]="{ 'is-hidden': tab != 2}">
            <div class="tabs is-boxed">
              <ul>
                <li [ngClass]="{ 'is-active' : tab2 == 1}">
                  <a (click)="tab2=1">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Quienes somos?</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 2}">
                  <a (click)="tab2=2">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Historia</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 3}">
                  <a (click)="tab2=3">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Misión</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 4}">
                  <a (click)="tab2=4">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Visión</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 5}">
                  <a (click)="tab2=5">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Valores</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 6}">
                  <a (click)="tab2=6">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Pensamientos</span>
                  </a>
                </li>
                <li [ngClass]="{ 'is-active' : tab2 == 7}">
                  <a (click)="tab2=7">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Politicas de privacidad</span>
                  </a>
                </li>

                <li [ngClass]="{ 'is-active' : tab2 == 8}">
                  <a (click)="tab2=8">
                    <span class="icon ">
                      <i class="fa fa-snowflake-o"></i>
                    </span>
                    <span>Video</span>
                  </a>
                </li>
              </ul>
            </div>
            <div [ngClass]="{ 'is-hidden': tab2 != 1}">
              <ckeditor formControlName="quienes" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 2}">
              <ckeditor formControlName="historia" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 3}">
              <ckeditor formControlName="mision" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 4}">
              <ckeditor formControlName="vision" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 5}">
              <ckeditor formControlName="valores" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 6}">
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 7}">
              <ckeditor formControlName="privacidad" debounce="500" [config]="CkeditorConfig"></ckeditor>
            </div>

            <div [ngClass]="{ 'is-hidden': tab2 != 8}">
              <nav class="panel">
                <p class="panel-heading">
                  Video promocional
                </p>
              </nav>
              <div class="box" style="margin-top: -20px; border-radius: 0px 0px 8px 8px;" formGroupName="video_promocional">
                <div class="media-content">
                  <div class="content">
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Contenedor:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="Contenedor" formControlName="containment">
                          </div>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Video URL:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="video URL" formControlName="videoURL">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Iniciar en el segundo:</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="Iniciar en el segundo" formControlName="startAt">
                          </div>
                        </div>
                      </div>
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Transparencia:
                            ({{100-(ctrl.dato.controls.configuracion.controls.video_promocional.controls.opacity.value
                            * 100)}}%)</label>
                          <div class="control has-icons-left has-icons-right">
                            <input class="input" type="range" min="0" max="1" step="0.1" placeholder="Transparencia"
                              formControlName="opacity">
                            <span class="icon is-small is-right" [style.opacity]="ctrl.dato.controls.configuracion.controls.video_promocional.controls.opacity.value">
                              <i class="fa fa-check"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="columns">
                      <div class="column is-6">
                        <br>
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="autoPlay" class="styled" type="checkbox" formControlName="autoPlay">
                            <label for="autoPlay">
                              Inicar al cargar la página?
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="column is-6">
                        <br>
                        <div class="field">
                          <div class="b-checkbox is-info">
                            <input id="mute" class="styled" type="checkbox" formControlName="mute">
                            <label for="mute">
                              Debe tener sonido?
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- contacto y redes -->
          <div [ngClass]="{ 'is-hidden': tab != 3}">
            <!-- contacto -->
            <nav class="panel">
              <p class="panel-heading">
                Medios de contactos
              </p>
              <div class="panel-block">
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('configuracion').value.contactos.length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Red</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="contactos">
                    <tr *ngFor="let medio of ctrl.dato.controls.configuracion.controls.contactos.controls; let suc = index"
                      [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_medios ? ctrl.tipos_medios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.tipos_medios_id.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.tipos_medios_id);"
                          [data]="ctrl.tipos_medios"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon" *ngIf="ctrl.tipos_medios">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !medio.controls.valor.valid}"
                            type="text">
                          <span class="icon is-small is-right">
                            <i [ngClass]="ctrl.tipos_medios[medio.controls.tipos_medios_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.contactos, suc)">
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.contactos, form_contactos)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </nav>

            <div class="field">
              <label class="label">Intro redes sociales:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Escriba un texto de introducción a las redes sociales"
                  formControlName="intro_redes">
                                          </textarea>
              </div>
            </div>
            <!-- redes sociales -->
            <nav class="panel">
              <p class="panel-heading">
                Redes Sociales
              </p>
              <div class="panel-block">
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('configuracion').value.redes_sociales.length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Red</th>
                      <th>Valor</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="redes_sociales">
                    <tr *ngFor="let medio of ctrl.dato.controls.configuracion.controls.redes_sociales.controls; let suc = index"
                      [formGroupName]="suc">
                      <td>{{ suc + 1 }}</td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_redes_sociales ? ctrl.tipos_redes_sociales.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="medio.controls.tipos_redes_sociales_id.value"
                          (valueChanged)="ctrl.seleccionarValorSelect2($event, medio.controls.tipos_redes_sociales_id);" [data]="ctrl.tipos_redes_sociales"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon" *ngIf="ctrl.tipos_redes_sociales">
                          <input class="input" formControlName="valor" placeholder="Valor" [ngClass]="{'is-danger': !medio.controls.valor.valid}"
                            type="text">
                          <span class="icon is-small is-right">
                            <i [ngClass]="ctrl.tipos_redes_sociales[medio.controls.tipos_redes_sociales_id.value - 1]?.icon"></i>
                          </span>
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.redes_sociales, suc)">
                          <i class="fa fa-trash-o"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.redes_sociales, form_redes_sociales)">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </nav>
            <!-- mapa -->
            <div class="field">
              <label class="label">Mapa Embebido:</label>
              <div class="control">
                <textarea class="textarea" rows="3" placeholder="Mapa compartido de google maps" formControlName="iframe_map">
                                          </textarea>
              </div>
            </div>
          </div>

          <!-- configuracion -->
          <div [ngClass]="{ 'is-hidden': tab != 4}">
            <div class="columns">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Moneda:</label>
                  <ng-select2 [disabled]="ctrl.tipos_monedas ? ctrl.tipos_monedas.length == 0 ? true : false : true" name="moneda" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.configuracion.controls.moneda.value"
                    (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.configuracion.controls.moneda);" [data]="ctrl.tipos_monedas"></ng-select2>
                </div>
              </div>
              <div class="column is-3">
                <div class="field">
                  <label class="label">Folio Tarjeta:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Folio tarjeta" formControlName="folioT">
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <div class="field">
                  <label class="label">Folio Efectivo:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Folio efectivo" formControlName="folioE">
                  </div>
                </div>
              </div>
              <div class="column is-2">
                <div class="field">
                  <label class="label">Margen de días:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Mes anterior" formControlName="dias_mes_anterior">
                  </div>
                </div>
              </div>
            </div>
            <!-- impuestos -->
            <div formGroupName="impuestos">
              <nav class="panel" formArrayName="traslados">
                <p class="panel-heading">
                  Impuestos trasladados
                </p>
                <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.configuracion.controls.impuestos.controls.traslados.controls; let i = index;">
                  <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                    <thead>
                      <tr>
                        <th>{{i+1}}</th>
                        <th>Impuesto:
                          <ng-select2 [disabled]="ctrl.catalogos_impuestos ? ctrl.catalogos_impuestos.length == 0 ? true : false : true" name="clave" [options]="ctrl.optionSelect" [value]="impuesto.controls.clave.value"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, impuesto.controls.clave);" [data]="ctrl.catalogos_impuestos"></ng-select2>
                        </th>
                        <th>Factor:
                          <ng-select2 [disabled]="ctrl.catalogos_factores ? ctrl.catalogos_factores.length == 0 ? true : false : true" name="factor" [options]="ctrl.optionSelect" [value]="impuesto.controls.factor.value"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, impuesto.controls.factor);" [data]="ctrl.catalogos_factores"></ng-select2>
                        </th>
                        <th>Cuota:
                          <input class="input" type="text" formControlName="cuota" id="cuota_tras{{i}}">
                        </th>
                        <td align="right">
                          <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.impuestos.controls.traslados, i)">
                            <i class="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    </thead>
                  </table>

                </div>
                <div class="panel-block">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.impuestos.controls.traslados, form_impuestos)">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </nav>

              <nav class="panel" formArrayName="retenciones">
                <p class="panel-heading">
                  Impuestos retenciones
                </p>
                <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.configuracion.controls.impuestos.controls.retenciones.controls; let i = index;">
                  <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                    <thead>
                      <tr>
                        <th>{{i+1}}</th>
                        <th>Impuesto:
                          <ng-select2 [disabled]="ctrl.catalogos_impuestos ? ctrl.catalogos_impuestos.length == 0 ? true : false : true" name="clave" [options]="ctrl.optionSelect" [value]="impuesto.controls.clave.value"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, impuesto.controls.clave);" [data]="ctrl.catalogos_impuestos"></ng-select2>
                        </th>
                        <th>Factor:
                          <ng-select2 [disabled]="ctrl.catalogos_factores ? ctrl.catalogos_factores.length == 0 ? true : false : true" name="factor" [options]="ctrl.optionSelect" [value]="impuesto.controls.factor.value"
                            (valueChanged)="ctrl.seleccionarValorSelect2($event, impuesto.controls.factor);" [data]="ctrl.catalogos_factores"></ng-select2>
                        </th>
                        <th>Cuota:
                          <input class="input" type="text" formControlName="cuota" id="cuota_ret{{i}}">
                        </th>
                        <td align="right">
                          <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.impuestos.controls.retenciones, i)">
                            <i class="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    </thead>
                  </table>

                </div>
                <div class="panel-block">
                  <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.impuestos.controls.retenciones, form_impuestos)">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </nav>
            </div>

            <div class="columns">

              <div class="column is-4">
                <div class="field">
                  <br>
                  <br>
                  <div class="b-checkbox is-info">
                    <input id="notificar_caja_cerrada" class="styled" type="checkbox" formControlName="notificar_caja_cerrada">
                    <label for="notificar_caja_cerrada">
                      Notificar si la caja esta cerrada ?
                    </label>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <div class="field">
                  <br>
                  <br>
                  <div class="b-checkbox is-info">
                    <input id="recibo" class="styled" type="checkbox" formControlName="recibo">
                    <label for="recibo">
                      Imprimir recibos depues de la venta
                    </label>
                  </div>
                </div>
              </div>

              <div class="column is-4">
                <div class="field">
                  <br>
                  <br>
                  <div class="b-checkbox is-info">
                    <input id="devolver_cambio" class="styled" type="checkbox" formControlName="devolver_cambio">
                    <label for="devolver_cambio">
                      Devolver el cambio en PAGOS ?
                    </label>
                  </div>
                </div>
              </div>

            </div>

            <div class="columns">

              <div class="column is-6">
                <div class="field">
                  <br>
                  <br>
                  <div class="b-checkbox is-info">
                    <input id="imprimir_usuario_ticket" class="styled" type="checkbox" formControlName="imprimir_usuario_ticket">
                    <label for="imprimir_usuario_ticket">
                      Imprimir nombre de cajero en ticket ?
                    </label>
                  </div>
                </div>
              </div>

              <div class="column is-6">
                <div class="field">
                  <br>
                  <br>
                  <div class="b-checkbox is-info">
                    <input id="factura_al_instante" class="styled" type="checkbox" formControlName="factura_al_instante">
                    <label for="factura_al_instante">
                      Facturar al momento de ejecutar el cobro
                    </label>
                  </div>
                </div>
              </div>

            </div>
            <div class="columns">


              <div class="column is-12">
                <div class="field">
                  <label class="label">Porcentaje de materias aprobadas para tener derecho a recursarce:</label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" type="number" placeholder="porcentaje" formControlName="porcentaje_materias_para_recurse">
                  </div>
                </div>
              </div>
            </div>

            <nav class="panel">
              <p class="panel-heading">
                Conversiones de moneda
              </p>
              <div class="panel-block">
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('configuracion').value.conversiones_monedas.length > 0">
                  <thead>
                    <tr>
                      <th hide-sm>ID</th>
                      <th>Nombre</th>
                      <th>Moneda</th>
                      <th>Cambio</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody formArrayName="conversiones_monedas">
                    <tr *ngFor="let moneda of ctrl.dato.controls.configuracion.controls.conversiones_monedas.controls; let cm = index"
                      [formGroupName]="cm">
                      <td>{{ cm + 1 }}</td>
                      <td>
                        <p class="control has-icon">
                          <input class="input" formControlName="nombre" placeholder="Nombre" type="text">
                        </p>
                      </td>
                      <td>
                        <ng-select2 [disabled]="ctrl.tipos_monedas ? ctrl.tipos_monedas.length == 0 ? true : false : true" name="moneda" [options]="ctrl.optionSelect" [value]="moneda.controls.moneda.value" (valueChanged)="ctrl.seleccionarValorSelect2($event, moneda.controls.moneda);"
                          [data]="ctrl.tipos_monedas"></ng-select2>
                      </td>
                      <td>
                        <p class="control has-icon">
                          <input class="input" formControlName="tipo_cambio" placeholder="Cambio" [ngClass]="{'is-danger': !ctrl.dato.controls.configuracion.controls.conversiones_monedas.controls[cm].controls.tipo_cambio.valid}"
                            type="number" min="0">
                        </p>

                      </td>
                      <td align="right">
                        <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.configuracion.controls.conversiones_monedas, cm)">
                          <i class="icon-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="button is-primary is-outlined is-fullwidth" style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.configuracion.controls.conversiones_monedas, form_conversiones_monedas)">
                  <i class="icon-add2"></i>
                </button>
              </div>
            </nav>

          </div>

          <!-- facturacion -->
          <div [ngClass]="{ 'is-hidden': tab != 5}" formGroupName="facturacion">

            <div class="field">
              <label class="label">Usuario:</label>
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="Usuario" formControlName="use_facturatelo">
              </div>
            </div>
            <div class="field">
              <label class="label">Password:</label>
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="Contraseña" formControlName="pwd_facturatelo">
              </div>
            </div>

            <div class="field">
              <label class="label">Tipo persona:</label>
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info" style="float:left">
                  <input id="fisica" class="styled" name="persona" (click)="seleccionar_persona('fisica')" [checked]="ctrl.dato.get('configuracion').value.facturacion.persona == 'fisica'"
                    value="fisica" type="radio" formControlName="persona">
                  <label for="fisica">
                    Fisica
                  </label>
                </div>

                <div class="b-checkbox is-info">
                  <input id="moral" class="styled" name="persona" (click)="seleccionar_persona('moral')" [checked]="ctrl.dato.get('configuracion').value.facturacion.persona == 'moral'"
                    value="moral" type="radio" formControlName="persona">
                  <label for="moral">
                    Moral
                  </label>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label">Razón social:</label>
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="Razón social" formControlName="razon_social">
              </div>
            </div>

            <div class="field">
              <label class="label">RFC:</label>
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="RFC" formControlName="rfc">
              </div>
            </div>

            <div class="field">
              <label class="label">Lugar de expedición:</label>
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="Lugar de expedición" formControlName="lugar_expedicion">
              </div>
            </div>

            <div class="field">
              <label class="label">Régimen fiscal:</label>
              <div class="control has-icons-left has-icons-right">
                <ng-select2 [disabled]="ctrl.catalogos_regimenes_fiscales ? ctrl.catalogos_regimenes_fiscales.length == 0 ? true : false : true" name="regimen_fiscal" placeholder="Régimen fiscal" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.configuracion.controls.facturacion.controls.regimen_fiscal?.value"
                  (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.configuracion.controls.facturacion.controls.regimen_fiscal);"
                  [data]="ctrl.catalogos_regimenes_fiscales"></ng-select2>
              </div>
            </div>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>
